var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('TinymceEditor',{attrs:{"init":_vm.completeSetting,"disabled":_vm.disabled},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }